import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {
  BackButtonComponent,
  FieldComponent,
  FieldSingleFormComponent,
  GridFormComponent,
  MultiSelectComponent,
  SingleFormComponent,
  FieldGridFormComponent,
  ImportButtonComponent,
  DetailModalComponent,
  FilterPaneComponent,
  TreeGridDropdownFilterComponent,
  RowButtonPaneComponent,
  TreeGridFormComponent,
  SearchPaneComponent,
  FilterItemConditionComponent,
  FilterItemValueComponent
} from './component';
import {UserButtonDirective, UserGridEditFormDirective, UserFieldDirective} from './directive';
import {RouterModule} from '@angular/router';

import {NumberFormatPipe} from './pipe';
import {LayoutModule} from '@progress/kendo-angular-layout';
import {ButtonsModule} from '@progress/kendo-angular-buttons';
import {DateInputModule, DatePickerModule, DateTimePickerModule} from '@progress/kendo-angular-dateinputs';
import {CheckBoxModule, NumericTextBoxModule, SliderModule, SwitchModule, TextBoxModule} from '@progress/kendo-angular-inputs';
import {AutoCompleteModule, ComboBoxModule, DropDownListModule, MultiSelectModule} from '@progress/kendo-angular-dropdowns';
import {DialogModule} from '@progress/kendo-angular-dialog';
import {GridModule} from '@progress/kendo-angular-grid';
import {PagerModule} from '@progress/kendo-angular-pager';
import {IconModule, SVGIconModule} from '@progress/kendo-angular-icons';
import {ContextMenuModule} from '@progress/kendo-angular-menu';
import {PopupModule} from '@progress/kendo-angular-popup';
import {TreeListModule} from '@progress/kendo-angular-treelist';
import { TreeDropdownComponent } from './component';
import {TreeViewModule} from '@progress/kendo-angular-treeview';
import { MultiSelectDetailComponent } from './component';


@NgModule({
  declarations: [FieldComponent, UserButtonDirective,
    BackButtonComponent, GridFormComponent,
    SingleFormComponent, MultiSelectComponent, NumberFormatPipe, UserFieldDirective, ImportButtonComponent,
    DetailModalComponent, FilterPaneComponent, RowButtonPaneComponent,
    FieldSingleFormComponent, FieldGridFormComponent, UserGridEditFormDirective,
    TreeGridFormComponent, TreeGridDropdownFilterComponent, TreeDropdownComponent,
    MultiSelectDetailComponent, SearchPaneComponent, FilterItemConditionComponent, FilterItemValueComponent],
  imports: [
    CommonModule,
    FormsModule,
    RouterModule,
    ReactiveFormsModule,
    LayoutModule,
    ButtonsModule,
    DatePickerModule,
    DateTimePickerModule,
    NumericTextBoxModule,
    CheckBoxModule,
    DropDownListModule,
    MultiSelectModule,
    ComboBoxModule,
    TextBoxModule,
    AutoCompleteModule,
    DialogModule,
    GridModule,
    PagerModule,
    SliderModule,
    IconModule,
    SVGIconModule,
    ContextMenuModule,
    SwitchModule,
    PopupModule,
    TreeListModule,
    TreeViewModule,
    DateInputModule
  ],
  exports: [FieldComponent, UserButtonDirective, UserFieldDirective, BackButtonComponent,
    GridFormComponent, SingleFormComponent, ImportButtonComponent, MultiSelectComponent,
    FieldSingleFormComponent, FieldGridFormComponent, UserGridEditFormDirective, NumberFormatPipe,
    TreeGridFormComponent, TreeDropdownComponent, DetailModalComponent, RowButtonPaneComponent, FilterPaneComponent,
    MultiSelectDetailComponent, SearchPaneComponent, FilterItemConditionComponent, FilterItemValueComponent
  ]
})

export class FormModule {
}
